export default {
    closures:[],
    pagination:{}
}